import { motion } from "framer-motion";
import { FACILITY_IMAGE } from "@/lib/constants";

const stats = [
  { value: "8", label: "Modalities under one roof" },
  { value: "5.0", label: "Google rating from our guests" },
  { value: "Free", label: "First guided session", accent: true }
];

export const Trust = () => (
  <section className="mx-auto max-w-7xl px-5 py-28 md:px-10 md:py-40" data-testid="trust-section">
    <div className="grid gap-16 lg:grid-cols-2 lg:gap-24">
      <div className="flex flex-col justify-center">
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-rest-blue">Why REST</p>
        <h2 className="font-display text-4xl font-black uppercase tracking-tighter md:text-5xl">
          Built for people who<br />don't do half-recovery
        </h2>
        <p className="mt-8 max-w-md text-base leading-relaxed text-zinc-400">
          REST Recovery was designed from the ground up as a performance destination — clinical-grade equipment,
          guided protocols, and a team that treats your recovery with the same seriousness you bring to training.
        </p>
        <div className="mt-12 grid grid-cols-3 gap-6">
          {stats.map((s) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="border-l border-white/15 pl-4"
            >
              <span className={`font-display text-4xl font-black tracking-tighter md:text-5xl ${s.accent ? "text-rest-red" : ""}`}>
                {s.value}
              </span>
              <p className="mt-2 text-xs leading-snug text-zinc-500">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, clipPath: "inset(8% 8% 8% 8%)" }}
        whileInView={{ opacity: 1, clipPath: "inset(0% 0% 0% 0%)" }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
        className="relative overflow-hidden border border-white/10"
      >
        <img
          src={FACILITY_IMAGE}
          alt="Inside the REST Recovery facility in North Phoenix"
          loading="lazy"
          className="aspect-[4/3] w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
        <span className="absolute bottom-5 left-5 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-300">
          REST Recovery — North Phoenix, AZ
        </span>
      </motion.div>
    </div>
  </section>
);
